import React from "react";

import { Wrapper, Content } from "./Skills.styles";

const Skills = () => (
  <Wrapper>
    <Content>
      <h1>Tech Skills</h1>
      <section>
        <ul>
          <li>JavaScript</li>
          <li>ReactJs</li>
          <li>CSS</li>
          <li>Tailwind CSS</li>
        </ul>
        <ul>
          <li>Python</li>
          <li>Django</li>
          <li>Flask</li>
          <li>NodeJs</li>
        </ul>
        <ul>
          <li>Java</li>
          <li>PostgreSQL</li>
          <li>SQLite</li>
          <li>Git</li>
        </ul>
        <ul>
          <li>Algorithms</li>
          <li>Data Structures</li>
          <li>Figma</li>
          <li>Vector design</li>
        </ul>
      </section>
    </Content>
  </Wrapper>
);

export default Skills;
